const en = {
    newFolder: 'New folder',
    name: 'Folder name',
    create: 'Create',
    creating: 'Creating…',
    cancel: 'Cancel',
    location: 'Create in',
    created: 'Folder created:',
    refresh: 'Refresh file list',
    refreshFailed: 'Unable to refresh the file list. Please try again.',
    emptyName: 'Enter a folder name.',
    reservedName: 'The names “.” and “..” are reserved.',
    invalidName: 'Use a name without /, \\ or null characters.',
    alreadyExists: 'A file or folder with this name already exists.',
    forbidden: 'You do not have permission to create a folder here.',
    parentUnavailable:
        'This location is no longer available. Refresh the file list.',
    unconfirmed:
        'Unable to confirm creation. Refresh the file list before trying again.',
}

const ru: Record<keyof typeof en, string> = {
    newFolder: 'Новая папка',
    name: 'Название папки',
    create: 'Создать',
    creating: 'Создаём…',
    cancel: 'Отмена',
    location: 'Создать в',
    created: 'Папка создана:',
    refresh: 'Обновить список',
    refreshFailed: 'Не удалось обновить список файлов. Попробуйте ещё раз.',
    emptyName: 'Введите название папки.',
    reservedName: 'Названия «.» и «..» зарезервированы.',
    invalidName: 'Название не должно содержать /, \\ или нулевой символ.',
    alreadyExists: 'Файл или папка с таким названием уже существует.',
    forbidden: 'У вас нет прав на создание папки в этом месте.',
    parentUnavailable: 'Эта папка больше недоступна. Обновите список файлов.',
    unconfirmed:
        'Не удалось подтвердить создание. Обновите список файлов перед повторной попыткой.',
}

export const folderMessages = { en, ru }
